import { render, staticRenderFns } from "./VirtualPlacementInquire.vue?vue&type=template&id=12175f22&scoped=true&"
import script from "./VirtualPlacementInquire.vue?vue&type=script&lang=js&"
export * from "./VirtualPlacementInquire.vue?vue&type=script&lang=js&"
import style0 from "./VirtualPlacementInquire.vue?vue&type=style&index=0&id=12175f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12175f22",
  null
  
)

export default component.exports